import React, { useEffect, useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import StaffOverviewCard from '../../../components/partials/staff/StaffOverviewCard'
import StaffDetails from '../../../components/partials/staff/StaffDetails'
import StaffEmployment from '../../../components/partials/staff/StaffEmployment'
import StaffEmergencyContacts from '../../../components/partials/staff/StaffEmergencyContacts'
import StaffBankDetails from '../../../components/partials/staff/StaffBankDetails'
import StaffDocuments from '../../../components/partials/staff/StaffDocuments'
import { authHeader, baseUrl } from '../../../utils'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ERROR } from '../../../store/types'
import Loader from '../../../components/elements/Loader'
import Breadcrumbs from '../../../components/elements/Breadcrumbs'

const CollegeStaffProfile = () => {
  const breadcrumbsData = [
    {
      label: 'Dashboard',
      path: '/admin/dashboard'
    },
    {
      label: 'College Staff',
      path: '/admin/college-staff'
    },
    {
      label: '',
      path: '',
      current: true
    },
  ]
  
  const { staffId } = useParams()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [staffDetails, setStaffDetails] = useState(null)
  // eslint-disable-next-line no-unused-vars
  const [reload, setReload] = useState(0)

  useEffect(() => {
    const fetchStaffMember = async () => {
      try {
        const headers = authHeader()
        const response = await axios.get(`${baseUrl}/staff/${staffId}?expand=department,designations,invitation,departmentHistory.department,designationHistory.designation`, { headers })
        
        setStaffDetails(response.data.data)
        setLoading(false)
      } catch (error) {
        console.error(error)
        dispatch({
          type: ERROR,
          error
        })
        setLoading(false)
      }
    }

    fetchStaffMember()

    return () => {}
  }, [staffId, dispatch, reload])
  
  const staffTabs = [
    {
      label: "Personal Details",
      value: 'details'
    },
    {
      label: "Employment",
      value: 'employment'
    },
    {
      label: "Emergency Contacts",
      value: 'emergency-contacts'
    },
    {
      label: "Bank Details",
      value: 'bank-details'
    },
    {
      label: "Documents",
      value: 'documents'
    },
  ]

  const [activeTabIndex, setActiveTabIndex] = useState(0)

  const changeTab = (tabIndex) => {
    setActiveTabIndex(tabIndex)
  }

  return (
    <Layout pageTitle={`Staff Profile`}>
      <div className='w-full max-w-[1500px] mx-auto py-6'>
        <Breadcrumbs breadcrumbsData={breadcrumbsData} />
        {loading ? 
          <Loader />
          :
          <div className='mt-6 flex flex-col items-start gap-6 xl:flex-row'>
            <div className='w-full xl:w-[250px] xl:shrink-0 xl:sticky xl:top-[100px]'>
              <StaffOverviewCard staff={staffDetails} />
            </div>
            <div className='w-full'>
              <div className='flex w-full gap-1 overflow-x-auto border-b border-gray-200'>
                {staffTabs.map((tab, tabIndex) => (
                  <button 
                    key={tabIndex} 
                    className={`whitespace-nowrap rounded-t-lg px-4 py-3 text-sm font-medium transition ${activeTabIndex === tabIndex ? 'border-b-2 border-vcm-purple bg-vcm-light-purple/20 text-vcm-purple' : 'text-vcm-dark-gray hover:bg-gray-50 hover:text-vcm-purple'}`}
                    onClick={() => {changeTab(tabIndex)}}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              <div className='pt-5'>
                {staffTabs[activeTabIndex].value === 'details' && (
                  <StaffDetails staff={staffDetails} />
                )}

                {staffTabs[activeTabIndex].value === 'employment' && (
                  <StaffEmployment staff={staffDetails} reload={() => setReload(reload+1)} />
                )}

                {staffTabs[activeTabIndex].value === 'emergency-contacts' && (
                  <StaffEmergencyContacts staff={staffDetails} />
                )}

                {staffTabs[activeTabIndex].value === 'bank-details' && (
                  <StaffBankDetails staff={staffDetails} />
                )}

                {staffTabs[activeTabIndex].value === 'documents' && (
                  <StaffDocuments staff={staffDetails} />
                )}
              </div>
            </div>
          </div>
        }
      </div>
    </Layout>
  )
}

export default CollegeStaffProfile
